
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


/*****************
 ** WEBPACK FOOTER
 ** /var/www/smartwifi/shared/~/component-inherit/index.js
 ** module id = 976
 ** module chunks = 1
 **/